// extracted by mini-css-extract-plugin
module.exports = {"Timetitle":"Sidebar_Timetitle__307Dj","timewrapper":"Sidebar_timewrapper__1lhuu","timedtool":"Sidebar_timedtool__31r7u"};